import React from 'react';

const Image = ({ src, alt = '' }) => {
  return (
    <img src={`/assets/${src}`} alt={alt}/>
  );
};
export default Image;
